"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraftAddonDto = exports.CreateDraftAddonDto = exports.EditAddonDto = exports.EditReservationAddonsDto = exports.EditAddonsDto = exports.AddAddonsDto = exports.AddonDto = exports.BaseAddonDto = exports.SelectAddonDto = void 0;
class SelectAddonDto {
}
exports.SelectAddonDto = SelectAddonDto;
class BaseAddonDto extends SelectAddonDto {
}
exports.BaseAddonDto = BaseAddonDto;
class AddonDto extends BaseAddonDto {
}
exports.AddonDto = AddonDto;
class AddAddonsDto {
}
exports.AddAddonsDto = AddAddonsDto;
class EditAddonsDto {
}
exports.EditAddonsDto = EditAddonsDto;
class EditReservationAddonsDto extends EditAddonsDto {
}
exports.EditReservationAddonsDto = EditReservationAddonsDto;
class EditAddonDto {
}
exports.EditAddonDto = EditAddonDto;
class CreateDraftAddonDto extends BaseAddonDto {
}
exports.CreateDraftAddonDto = CreateDraftAddonDto;
class DraftAddonDto extends BaseAddonDto {
}
exports.DraftAddonDto = DraftAddonDto;
//# sourceMappingURL=addon.dto.js.map